import { useAgencyStore } from '@/stores/agency/useAgencyStore';
import { useInsertionsStore } from '@/stores/insertions/useInsertionsStore';
import { findInsertionById } from '@/stores/types/insertions';
import { useUserStore } from '@/stores/user/useUserStore';

/**
 * Resolves the owner id used to scope an insertion refetch.
 *
 * The Manage Ads list is the authoritative source. `fallbackUserId` and the active
 * agency person cover the flows that reach the store before that list exists, for
 * example a poll started right after a wizard publish.
 */
export const resolveInsertionOwnerId = (
  insertionId: string,
  fallbackUserId?: string,
): string | undefined =>
  findInsertionById(useInsertionsStore().insertions, insertionId)?.userId ??
  fallbackUserId ??
  useAgencyStore().activeAgencyPersonId ??
  (useUserStore().logonId || undefined);
